// import middleware from "./middleware";
import loadjs from "loadjs";

window.loadjs = loadjs;

import "./_antd1.11.2/button/style";
import "./_antd1.11.2/message/style";
import "./_antd1.11.2/icon/style";
import "./_antd1.11.2/checkbox/style";
import "./_antd1.11.2/input/style";
import "./_antd1.11.2/radio/style";
import "./_antd1.11.2/tabs/style";
import "./_antd1.11.2/row/style";
import "./_antd1.11.2/col/style";
import "./_antd1.11.2/card/style";
import "./_antd1.11.2/switch/style";
import "./_antd1.11.2/menu/style";
import "./_antd1.11.2/modal/style";
import * as History from "./history-3.3.0/modules/index";

window.History = History;

// export { default as Button } from "./_antd1.11.2/button";
// export { default as message } from "./_antd1.11.2/message";
// export { default as Icon } from "./_antd1.11.2/icon";
// export { default as Checkbox } from "./_antd1.11.2/checkbox";
// export { default as Input } from "./_antd1.11.2/input";
// export { default as Radio } from "./_antd1.11.2/radio";
// export { default as Tabs } from "./_antd1.11.2/tabs";
// export { default as Row } from "./_antd1.11.2/row";
// export { default as Col } from "./_antd1.11.2/col";
// export { default as Card } from "./_antd1.11.2/card";
// export { default as SelectNew } from "./_antd1.11.2/select-new";
// export { default as Switch } from "./_antd1.11.2/switch";

import { default as A } from "./_antd1.11.2/button";
import { default as B } from "./_antd1.11.2/message";
import { default as C } from "./_antd1.11.2/icon";
import { default as D } from "./_antd1.11.2/checkbox";
import { default as E } from "./_antd1.11.2/input";
import { default as F } from "./_antd1.11.2/radio";
import { default as G } from "./_antd1.11.2/tabs";
import { default as H } from "./_antd1.11.2/row";
import { default as I } from "./_antd1.11.2/col";
import { default as J } from "./_antd1.11.2/card";
import { default as K } from "./_antd1.11.2/select-new";
import { default as L } from "./_antd1.11.2/switch";
import { default as M } from "./_antd1.11.2/menu";
// import { default as N } from "./_antd1.11.2/modal";

export const Pagination = () => null;
export const Table = () => null;
// export const Modal = () => null;

export const Button = A;
export const message = B;
export const Icon = C;
export const Checkbox = D;
export const Input = E;
export const Radio = F;
export const Tabs = G;
export const Row = H;
export const Col = I;
export const Card = J;
export const SelectNew = K;
export const Switch = L;
export const Menu = M;

function noop() {}
const AntdModal = () => Null;
["info", "success", "error", "warn", "warning", "confirm"].forEach(k => {
  AntdModal[k] = noop;
});

export const Modal = AntdModal;
// export const Button = middleware(A, "Button");
// export const message = middleware(B, "message");
// export const Icon = middleware(C, "Icon");
// export const Checkbox = middleware(D, "Checkbox");
// export const Input = middleware(E, "Input");
// export const Radio = middleware(F, "Radio");
// export const Tabs = middleware(G, "Tabs");
// export const Row = middleware(H, "Row");
// export const Col = middleware(I, "Col");
// export const Card = middleware(J, "Card");
// export const SelectNew = middleware(K, "SelectNew");
// export const Switch = middleware(L, "Switch");



// WEBPACK FOOTER //
// ./_ro_antd.js